import { render, staticRenderFns } from "./FTPDisableModal.vue?vue&type=template&id=065537af&"
import script from "./FTPDisableModal.vue?vue&type=script&lang=js&"
export * from "./FTPDisableModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports